export const API_URL = 'https://api.reaktor.io';
export const LOCAL_API_URL = '/api';
export const RUM_API_URL = 'https://events.reaktor.io/track';

export const getApiUrl = (): string => LOCAL_API_URL;

export const createEnvironment = (
  appId: string,
  name: string,
  rumEnabled: boolean = import.meta.env.PROD,
  analyticsId?: string
) => {
  const apiUrl = getApiUrl();

  return {
    app: {
      api: {
        endpoints: {
          rum: rumEnabled ? RUM_API_URL : '/track',
          session: '/auth/session'
        },
        public: apiUrl,
        rum: apiUrl,
        url: apiUrl
      },
      name,
      rum: {appId: analyticsId || appId, enabled: rumEnabled && Boolean(analyticsId)}
    }
  };
};
